import {GetStaticPaths, GetStaticProps} from "next";
import {getAllPagesWithSlug, getPageForSlug} from "../../../lib/api";
import {useRouter} from "next/router";
import ErrorPage404 from "../../../components/404";
import Layout from "../../../components/layout";
import dynamic from "next/dynamic";
import CallToActionSmall from "../../../components/v2/call-to-action-sm";
import RumSessionReplay from "../../../templates/product/rum/rum-session-replay";
import RumErrorTracking from "../../../templates/product/rum/rum-error-tracking";
import MobileRum from "../../../templates/product/rum/mobile-rum";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";

const PARENT_PAGE = 'product';
const SUB_PARENT_PAGE = 'real-user-monitoring';

const CommonPageTemplate = dynamic(() => import('../../../templates/common'));


export default function RUMSession({ pageData, ...props }) {
    const router = useRouter();

    if (router.isFallback) {
        return <div>Loading...</div>;
    }

    const page = pageData?.pages?.edges?.[0]?.node;

    if (!page?.slug) {
        return <ErrorPage404 />;
    }
    let component

    switch (page?.slug) {
        case "session-replays":
            component = <RumSessionReplay />;
            break;
        case "error-tracking":
            component = <RumErrorTracking  />;
            break;
        case "mobile-rum":
            component = <MobileRum  />;
            break;
        default:
            component = <CommonPageTemplate pageData={pageData}/>;
    }

    return <>
        <Layout isHomePage={page?.isFrontPage} pageTitle={page?.title}
                uri={page?.uri}
                metaTitle={page?.seo?.title}
                metaDesc={page?.seo?.metaDesc}
                ogImage={page?.featuredImage?.node?.sourceUrl}
                metaRobotsNoindex={page?.seo?.metaRobotsNoindex}
                metaRobotsNofollow={page?.seo?.metaRobotsNofollow}>
            <div className={`middle-wrapper site-page ${PARENT_PAGE} ${SUB_PARENT_PAGE} ${page.slug}-page`}>
                {component}
                <CallToActionSmall/>
            </div>
        </Layout>
    </>
}

export const getStaticProps: GetStaticProps = async ({
    params,
    preview = false,
    previewData,
    locale,
}) => {
const data = await getPageForSlug(params?.slug,PARENT_PAGE,SUB_PARENT_PAGE)

let page = data?.pages?.edges?.[0]?.node

return {
props: {
pageData: data,
pageTitle: page?.seo?.title,
description:page?.seo?.metaDesc,
ogImage:page?.featuredImage?.node?.sourceUrl || null,
uri:page?.uri,
metaTitle:page?.seo?.title,
metaDesc:page?.seo?.metaDesc,
metaRobotsNoindex:page?.seo?.metaRobotsNoindex,
metaRobotsNofollow:page?.seo?.metaRobotsNofollow,
...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer', 'home'], nextI18NextConfig)),
},
// revalidate: 10,
}
}

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
    const allPages = await getAllPagesWithSlug()
    const paths: { params: { slug: string }, locale?: string }[] = []

    allPages.edges.forEach((item)=>{
        if(item.node?.parent?.node.slug === SUB_PARENT_PAGE){
            if (locales && locales.length > 0) {
                locales.forEach((locale) => {
                    paths.push({
                        params: { slug: item.node.slug },
                        locale,
                    })
                })
            } else {
                paths.push({
                    params: { slug: item.node.slug },
                })
            }
        }
    })

    return {
        paths,
        fallback: false,
    }
}

